import React from 'react'
import PropTypes from 'prop-types'
import { Container, Heading } from '@scentregroup/ui'
import classNames from 'classnames'
import ShowMore from '../show-more'
import { SEE_MORE_TEXT } from '../../constants'
import style from './index.scss'
import Card from './card'

const CardList = ({
  superHeading,
  heading,
  cards,
  className,
  minItems,
  buttonText,
}) => (
  <Container type="large" className={classNames(style.CardList, className)}>
    {superHeading && (
      <Heading type="extrasmall" className={style.CardListSuperHeading}>
        {superHeading}
      </Heading>
    )}
    {heading && <Heading type="large">{heading}</Heading>}
    <div className={style.cardListItems}>
      <ShowMore minItems={minItems} buttonText={buttonText}>
        {cards.map(card => (
          <Card className={style.cardListItem} key={card.title} {...card} />
        ))}
      </ShowMore>
    </div>
  </Container>
)

CardList.propTypes = {
  className: PropTypes.string,
  superHeading: PropTypes.string,
  heading: PropTypes.string,
  cards: PropTypes.array.isRequired,
  minItems: PropTypes.number,
  buttonText: PropTypes.string,
}

CardList.defaultProps = {
  minItems: null,
  buttonText: SEE_MORE_TEXT,
  heading: '',
}

export default CardList
